import type { Product } from 'app/features/recommend/interfaces/models';
import type { GetRecommendedProductResponse } from '~/api/aspida/@types';
import { StandardShoeSize } from '~/features/size/size';

type ProductData = GetRecommendedProductResponse['products'][number];

export const productAdapter = (data: ProductData): Product => {
  const product: Product = {
    product_id: data.product_id,
    name: data.name,
    link: data.link,
    image: data.image_url ?? '',
    alt_image: data.alt_image_url ?? '',
    size: new StandardShoeSize(Number(data.size_text), data.unit),
    description: data.description,
    currency: data.currency,
    item_brand: data.item_brand,
    item_category: data.item_category,
    price: data.price,
    affiliation: data.affiliation,
  };

  return product;
};
